export const primaryColor = "rgb(0, 29, 76)",
  secondaryColor = "#00bfff",
  textwhite = "white",
  faintWhite = "#ffffff40",
  errorColor = "#ff0000";
